import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material';

export const useStyles = makeStyles<Theme>((theme) => ({
  appBar: {
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  title: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
}));
